import './Header.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FavSwitcher from './FavSwitcher';
import LangSwitcher from './LangSwitcher';
import logo from './logo.svg';
import React from 'react';

const Header = () => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const event = useSelector(state => state.event);
	const lang = i18n.language;

	return (
	    <div className='Header'>
			<div className='Header-logo' onClick={() => navigate('/cabinet')}>
				<img src={logo} alt='logo'/>
			</div>
			<div className='Header-text'>
			{event ?
				<React.Fragment>
					<big>{event.name[lang]}</big>
					<small>{t('common.catalog')}</small>
				</React.Fragment> :
				<React.Fragment>
				{t('common.catalog')}
				</React.Fragment>}
			</div>
			<div className='Header-menu'>
				<FavSwitcher/>
				<LangSwitcher/>
			</div>
        </div>
	);
};

export default Header;
